import {SampleBoardCheck} from "@app/strain/sample-boards/models/validate/sample-board-check.model";

export enum SampleBoardCheckStatus {
    Pending = 1,
    OK = 2,
    Nok = 3,
}

export class SampleBoardValidateCheck {
    id: number
    checkType: SampleBoardCheck;
    status: SampleBoardCheckStatus;

    constructor(entry: any = {}) {
        this.id = entry?.id || null;
        this.checkType = entry?.checkType  ? entry.checkType : null;
        this.status = entry?.status;
    }
}
